import React from "react";
import { useParams } from "react-router-dom";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import AffiliationAssignmentsTable from "./AffiliationAssignmentsTable";

const UserAffiliations = () => {
  const { userId } = useParams();

  return (
    <div>
      <WidgetSectionTitle
              className="mt-4 mb-4"
              title="User Affiliations"
              icon="users"
              subtitle="User Affiliations that categorize users."
            />
      <AffiliationAssignmentsTable/>
    </div>
  );
};

export default UserAffiliations;
